import Navbar from './Navbar'
import Footer from './Footer'
import React, { useState } from "react";
import Swal from "sweetalert2";

const Contact = () => {
  
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: ""
  });
  
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Phone only numbers
    const newValue = name === "phone"
      ? value.replace(/[^0-9]/g, "")
      : value;

    setFormData({
      ...formData,
      [name]: newValue
    });

    // Clear error for this field when user starts typing
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: null
      });
    }
  };

  const validate = () => {
    let newErrors = {};

    if (!formData.firstName.trim()) {
      newErrors.firstName = "First name is required";
    }

    if (!formData.lastName.trim()) {
      newErrors.lastName = "Last name is required";
    }

    if (!formData.email) {
      newErrors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Enter valid email address";
    }

    if (!formData.phone) {
      newErrors.phone = "Phone number is required";
    } else if (formData.phone.length !== 10) {
      newErrors.phone = "Phone number must be 10 digits";
    }

    if (!formData.message.trim()) {
      newErrors.message = "Message is required";
    }

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const validationErrors = validate();

    if (Object.keys(validationErrors).length > 0) {
      Swal.fire({
        title: "Oops!",
        text: "Please fill all required fields correctly.",
        icon: "error",
        confirmButtonColor: "#d33"
      });
      setErrors(validationErrors);
      return;
    }

    // Start submission
    setIsSubmitting(true);

    try {
      // Prepare data for API (matching the field names expected by backend)
      const contactData = {
        first_name: formData.firstName,
        last_name: formData.lastName,
        email: formData.email,
        phone: formData.phone,
        message: formData.message
      };

      // Send data to API
      const response = await fetch('https://evercorenutrition.com/ev_admin/api/contact/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          // Add any additional headers if required (like authentication tokens)
          // 'Authorization': 'Token your-token-here',
        },
        body: JSON.stringify(contactData)
      });

      const responseData = await response.json();

      if (!response.ok) {
        // Handle validation errors from server
        if (response.status === 400) {
          // Map server-side validation errors to form fields
          const serverErrors = {};
          Object.keys(responseData).forEach(key => {
            // Convert snake_case to camelCase for form fields
            const formField = key === 'first_name' ? 'firstName' :
                             key === 'last_name' ? 'lastName' : key;
            serverErrors[formField] = Array.isArray(responseData[key]) 
              ? responseData[key][0] 
              : responseData[key];
          });
          setErrors(serverErrors);
          
          Swal.fire({
            title: "Validation Error",
            text: "Please check the form for errors.",
            icon: "error",
            confirmButtonColor: "#d33"
          });
        } else {
          throw new Error('Failed to send message');
        }
      } else {
        // Success
        Swal.fire({
          title: "Message Sent!",
          text: "Thank you for contacting us. We will get back to you soon.",
          icon: "success",
          confirmButtonColor: "#0da487",
          confirmButtonText: "OK"
        });

        // console.log("Form Submitted", contactData);

        // Reset form
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          phone: "",
          message: ""
        });
        setErrors({});
      }
    } catch (error) {
      console.error('Submission error:', error);
      Swal.fire({
        title: "Error!",
        text: "Something went wrong. Please try again later.",
        icon: "error",
        confirmButtonColor: "#d33"
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Navbar/>
      
      {/* <!-- Breadcrumb Section Start --> */}
      <section className="breadcrumb-section pt-0">
        <div className="container-fluid-lg">
          <div className="row">
            <div className="col-12">
              <div className="breadcrumb-contain">
                <h2>Contact Us</h2>
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <a href="/">
                        <i className="fa-solid fa-house"></i>
                      </a>
                    </li>
                    <li className="breadcrumb-item active">Contact Us</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- Breadcrumb Section End --> */}

      {/* <!-- Contact Box Section Start --> */}
      <section className="contact-box-section" style={{paddingBottom:"50px"}}>
        <div className="container-fluid-lg">
          <div className="row g-lg-5 g-3">
            <div className="col-lg-6">
              <div className="left-sidebar-box">
                <div className="row">
                  <div className="col-xl-12">
                    <div className="contact-image">
                      <img 
                        src="../assets/images/vvvv.png"
                        className="img-fluid blur-up lazyloaded" 
                        alt="Contact Us" 
                        style={{borderRadius:"10px"}} 
                      />
                    </div>
                   
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="title d-xxl-none d-block">
                <h2>Contact Us</h2>
              </div>
              <div className="right-sidebar-box">
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-xxl-6 col-lg-12 col-sm-6">
                      <div className="mb-md-4 mb-3 custom-form">
                        <label htmlFor="firstName" className="form-label">First Name</label>
                        <div className="custom-input">
                          <input
                            type="text"
                            id="firstName"
                            name="firstName"
                            value={formData.firstName}
                            onChange={handleChange}
                            className={`form-control ${errors.firstName ? "is-invalid" : ""}`}
                            placeholder="Enter First Name"
                            disabled={isSubmitting}
                          />
                          {errors.firstName && (
                            <div className="invalid-feedback">{errors.firstName}</div>
                          )}
                          <i className="fa-solid fa-user"></i>
                        </div>
                      </div>
                    </div>

                    <div className="col-xxl-6 col-lg-12 col-sm-6">
                      <div className="mb-md-4 mb-3 custom-form">
                        <label htmlFor="lastName" className="form-label">Last Name</label>
                        <div className="custom-input">
                          <input
                            type="text"
                            id="lastName"
                            name="lastName"
                            value={formData.lastName}
                            onChange={handleChange}
                            className={`form-control ${errors.lastName ? "is-invalid" : ""}`}
                            placeholder="Enter Last Name"
                            disabled={isSubmitting}
                          />
                          {errors.lastName && (
                            <div className="invalid-feedback">{errors.lastName}</div>
                          )}
                          <i className="fa-solid fa-user"></i>
                        </div>
                      </div>
                    </div>

                    <div className="col-xxl-6 col-lg-12 col-sm-6">
                      <div className="mb-md-4 mb-3 custom-form">
                        <label htmlFor="email" className="form-label">
                          Email Address
                        </label>
                        <div className="custom-input">
                          <input
                            type="email"
                            id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            className={`form-control ${errors.email ? "is-invalid" : ""}`}
                            placeholder="Enter Email Address"
                            disabled={isSubmitting}
                          />
                          {errors.email && (
                            <div className="invalid-feedback">{errors.email}</div>
                          )}
                          <i className="fa-solid fa-envelope"></i>
                        </div>
                      </div>
                    </div>

                    <div className="col-xxl-6 col-lg-12 col-sm-6">
                      <div className="mb-md-4 mb-3 custom-form">
                        <label htmlFor="phone" className="form-label">
                          Phone Number
                        </label>
                        <div className="custom-input">
                          <input
                            type="tel"
                            id="phone"
                            name="phone"
                            maxLength={10}
                            value={formData.phone}
                            onChange={handleChange}
                            className={`form-control ${errors.phone ? "is-invalid" : ""}`}
                            placeholder="Enter Your Phone Number"
                            disabled={isSubmitting}
                          />
                          {errors.phone && (
                            <div className="invalid-feedback">{errors.phone}</div>
                          )}
                          <i className="fa-solid fa-mobile-screen-button"></i>
                        </div>
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="mb-md-4 mb-3 custom-form">
                        <label htmlFor="message" className="form-label">Message</label>
                        <div className="custom-textarea">
                          <textarea
                            id="message"
                            name="message"
                            value={formData.message}
                            onChange={handleChange}
                            rows="6"
                            className={`form-control ${errors.message ? "is-invalid" : ""}`}
                            placeholder="Enter Your Message"
                            disabled={isSubmitting}
                          />
                          {errors.message && (
                            <div className="invalid-feedback">{errors.message}</div>
                          )}
                          <i className="fa-solid fa-message"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <button 
                    type="submit" 
                    className="btn btn-animation btn-md fw-bold ms-auto border btn-primary"
                    disabled={isSubmitting}
                    style={{ opacity: isSubmitting ? 0.7 : 1, cursor: isSubmitting ? 'not-allowed' : 'pointer' }}
                  >
                    {isSubmitting ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Sending...
                      </>
                    ) : (
                      'Send Message'
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- Contact Box Section End --> */}

     
      
      <Footer/>
    </>
  )
}

export default Contact